import { PassengerFragment } from '@websky/graphql';
import { RefundPassengersState } from '../model/types';

export const getInitialPassengersState = (
	passengers: PassengerFragment[],
	initialValue: boolean = false
): RefundPassengersState => {
	const initialState: RefundPassengersState = {};

	passengers.forEach(passenger => {
		initialState[passenger.id] = initialValue;
	});

	return initialState;
};
